import type {MomentArm} from "./upgradeMomentArm";
import {MOMENT_EXPERIMENTS} from "./upgradeMomentArm";
import type {UpgradeMomentId} from "./upgradeMoments";

/**
 * `UPGRADE_MOMENT_ELIGIBLE`'s parameters (kitecorp/transferify-ui#2909, kitecorp/transferify-api-service#2169):
 * the moment a sender qualified for on this visit and the half of its test they are in. Sent in BOTH
 * halves, once per visit, as `game_offered` is for the games: it is each test's denominator, read
 * against purchases per client id. Nothing about the files, the address or the limit is in it.
 */
export function momentEligibleParams(moment: UpgradeMomentId, arm: MomentArm): Readonly<Record<string, string>> {
	return {moment: MOMENT_EXPERIMENTS[moment], variant: arm};
}
